module.exports = __webpack_public_path__ + "s/img/Chill_D_2.ab16ad09.jpg";